import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenDemo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 200 200",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.55,
			d: "M725.308 264.033c-.668.001-4.694-.084-4.673.586.044 1.39-.147 3.741-.147 5.062 0 1.874-.085 3.429 0 3.887.223 1.192 3.286.583 5.377.061",
			transform: "matrix(1.37601 0 0 1.20496 -900.288 -235.901)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.55,
			d: "M720.488 269.715c1.2-.136 2.464.016 3.883-.194",
			transform: "matrix(1.37601 0 0 1.20496 -900.288 -235.901)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9933884000000002,
			d: "M53.35 83.258c-1.116.318 4.508-3.078 5.505-3.831 3.575-2.706 7.28-5.224 10.893-7.874 11.616-8.518 23.101-17.154 35.294-24.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9933884000000002,
			d: "M53.205 83.279c.312 4.276.3 15.664.476 19.952.563 13.655.353 27.365-.365 41.016-.096 1.816-2.357 8.536.352 8.745 6.676.513 13.443.86 20.063.18 16.603-1.703 71.323 1.59 71.773.06 1.47-4.997-.062-33.474.617-42.86.258-3.557.485-7.119.825-10.666.02-.222.489-4.696.714-8.404"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9933884000000002,
			d: "M105.042 46.743c2.077-2.74 10.766 9.721 14.462 14.15 8.556 10.256 28.156 28.423 28.156 30.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9933884000000002,
			d: "M53.205 83.279c-.323-1.966 45.577 34.201 50.272 33.66 3.876-.448 36.005-21.178 44.183-25.637"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9933884000000002,
			d: "M72.716 96.612c-.192.672-.437-20.58.65-21.122 9.496-4.75 25.805-3.433 36.027-2.93 3.514.172 15.95.246 18.882 1.422.978.391.27 8.998.206 11.213-.234 8.073.942 9.946-.068 17.687"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.001224,
			d: "M78.355 83.543c-.533-.963.132 2.196.185 3.295.117 2.489-.245 5.666.55 8.052"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.001224,
			d: "M76.801 82.362c-1.238-.43 2.607.28 3.903.49 2.156.35 6.639 1.499 7.444 3.91 1.876 5.631-7.084 6.675-10.236 8.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.37,
			d: "M138.644 604.229s-.401-10.171 0-10.227 2.268 3.389 2.268 3.389 1.482-2.906 1.897-3.389c.415-.484 1.339 9.213 1.046 10.594",
			transform: "matrix(1.68015 0 0 1.20496 -131.818 -633.504)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.001224,
			d: "M117.035 82.222c-2.299.396-3.782 15.392 2.392 12.786 6.171-2.604 4.535-13.981-2.392-12.786"
		})
	]
});
export default SvgOpenDemo;
